import axios, { AxiosError, AxiosInstance } from 'axios';
import { baseUrl } from '../app/constants';
import { authProviderDefault } from '../providers/auth-provider';
import Snackbar from '../helpers/Snackbar.helper';

export const apiHttpService: AxiosInstance = axios.create({
  withCredentials: true,
  baseURL: baseUrl,
});

apiHttpService.interceptors.request.use(
  async (config) => {
    let token = await authProviderDefault.getAccessToken();

    config.headers = {
      Authorization: `Bearer ${token.accessToken}`,
      Accept: 'application/octet-stream',
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

apiHttpService.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 400 || error.response?.status === 500) {
      Snackbar.error(
        error.response?.data?.errorKey ||
          error.response?.data?.title ||
          'Unexpected error',
      );
    }
    return Promise.reject(error.response);
  },
);
